<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <h1>Large Texas City DRaas</h1>
      <h1>Case Study</h1>

      <h2>Large Municipal Government Agency Implements Cloud-Based Disaster Recovery Solution</h2>
      <img src="/assets/case-studies/migration-large-texas-city-draas-1.jpg" />
      
      <h2>About the Customer:</h2>
      <p>
        A major U.S. municipal government agency serving over 1 million residents needed to modernize their disaster recovery capabilities. The agency operates critical public services including emergency response, public works, libraries, and various administrative functions across multiple departments.
      </p>

      <h2>Customer Challenge:</h2>
      <p>
       The agency faced significant challenges with their existing disaster recovery infrastructure:
      </p>
      <ul>
        <li> Need to protect over 800 servers running critical municipal services.</li>
        <li> Complex compliance requirements including CJIS regulations for law enforcement data.</li>
        <li> Varying recovery time objectives (RTO) and recovery point objectives (RPO) for different application tiers.</li>
        <li> Limited bandwidth and network infrastructure for data replication.</li>
      </ul>

      <p>Without addressing these challenges, the agency risked extended service outages during disasters, potentially impacting essential public services and safety operations. They needed a solution that could meet strict RTOs ranging from 30 minutes for core services to 24 hours for lower-priority systems.</p>

      <h2>Partner Solution:</h2>
      <p>The partner implemented AWS Elastic Disaster Recovery (DRS) with a phased, application-by-application approach. Key solution components included:</p>
      <ul>
        <li> Deployment of multiple AWS staging accounts to handle the large server environment.</li>
        <li> Implementation of dedicated 2Gbps AWS Direct Connect for commercial workloads.</li>
        <li> Separate secure replication path over internet for CJIS-compliant systems.</li>
        <li> Custom network architecture utilizing both commercial AWS cloud and AWS GovCloud.</li>
        <li> Retention of existing IP addressing scheme with specialized routing configuration.</li>
        <li> Comprehensive agent deployment strategy with automated installation procedures.</li>
      </ul>

      <p>The solution was carefully designed to meet four distinct service tiers:</p>
      <ul>
        <li> Core services: 30-minute RTO, 15-minute RPO.</li>
        <li> Tier 1: 1-hour RTO, 15-minute RPO.</li>
        <li> Tier 2: 4-hour RTO, 2-hour RPO.</li>
        <li> Tier 3: 24-hour RTO, 4-hour RPO.</li>
      </ul>


      <h2>Results and Benefits</h2>
      <p>The implementation delivered significant improvements to the agency's disaster recovery capabilities:</p>
      <ul>
        <li>Successfully protected over 800 servers across multiple departments.</li>
        <li>Met all required RTO/RPO targets during testing.</li>
        <li>Achieved CJIS compliance requirements for sensitive law enforcement data.</li>
        <li>Reduced complexity through automated replication and recovery procedures.</li>
        <li>Enabled successful quarterly disaster recovery testing capabilities.</li>
        <li>Improved visibility into recovery readiness through AWS console.</li>
        <li>Enhanced ability to maintain essential public services during disasters.</li>
      </ul>

      <h2>About the Partner</h2>
      <p>The partner is a leading technology solutions provider specializing in public sector implementations. They have extensive experience in healthcare, state/local government, education, and commercial sectors, working with major technology vendors including AWS, Cisco, Dell, HP, and others. Their expertise spans data center, cloud, networking, security, and managed services solutions.</p>

    </div>
  </div>
</div>
